import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { Route } from 'src/app/core/route.service';
import {SpHmiConverterComponent } from './sp-hmi-converter.component';

const routes: Routes = Route.withShell([
  { path: 'comingSoon', component: SpHmiConverterComponent, data: { title: 'comingSoon' } }
]);

@NgModule({
  imports: [
    [RouterModule.forChild(routes)]
  ],
  exports: [RouterModule],
  declarations: []
})
export class SPHmiConverterRoutingModule { }
